document.addEventListener('DOMContentLoaded', function () {
const search_main = document.querySelector(".product-with-result")
const resault_skeleton = document.querySelector(".collection_search--skeleton")
const resault_amount = document.querySelector(".result-toolbar--text span block")
const product_grid = document.querySelector(".result-product-grid")
const filters_main = document.querySelector(".filters-container")
const filters_groups = document.querySelector(".filters-group-container")
const compare_wrapper = search_main.querySelector(".compare-wrapper")
const prev_page = document.querySelector(".collection-pagination__prev")
const next_page = document.querySelector(".collection-pagination__next")
const next_mb = document.querySelector(".collection-pagination-wrapper--mb")
let __page_index = 1
let __page_count = 1
let loading_next = false;
const mql = window.matchMedia('(max-width: 1024px)');
let collection_products = [];
const compare_limit = mql.matches ? 2 : 3;
const show_compare = document.querySelector(".collection-wrapper").getAttribute("data-show_compare") === "true"
let compare_products = [];
const fk_no_data = document.querySelector(".no_data_main")
const show_diff_text = document.querySelector(".collection-wrapper")?.getAttribute("data-show_diff") || ''
const selectedFilters = window.innerWidth >= 1024 ? document.querySelector(".selected-filters") : document.querySelector(".selected-filters--mb")


// 产品对比 - start
function handleUpdataCompareTitle() {
    if(!show_compare) return
    setTimeout(() => {
        try {
            document.querySelector(".compare-wrapper--header-title h2 block") && (document.querySelector(".compare-wrapper--header-title h2 block").textContent = compare_products.length)
        } catch (error) {
            console.log(error)
            console.log("comp block", document.querySelector(".compare-wrapper--header-title h2 block"))
            console.log("compare_products len", compare_products.lenght)
        }
    }, 20);
}

function handleEventCompareClear() {
    if(!show_compare) return
    const clear_btn = document.querySelector(".sheetButtons--clear");
    if(!clear_btn) return;
    function handleCompareClearClick() {
        compare_products = [];
        handleUpdataCompareTitle();
        
        document.querySelectorAll(".collection-product--compare input").forEach(item => {
            item.checked = false;
        })
        compare_wrapper.classList.remove("open");
        compare_wrapper.classList.remove("half");
        compare_wrapper.classList.remove("shoudong");
        document.querySelector(".collection-wrapper").classList.remove("max-num")
    }
    clear_btn.addEventListener("click", handleCompareClearClick)
}

function handleRemoveCompareItem(e) {
    if(!show_compare) return
    if(compare_products.length === 1) {
        document.querySelector(".sheetButtons--clear").click();
        return;
    }
    const target_item = e.target.closest(".compare--item");
    target_item.remove();
    compare_products = compare_products.filter(item => item.skuId.toString() !== target_item.getAttribute("data-sku"));
    handleUpdataCompareTitle();
    try {
        Array.from(document.querySelectorAll(".collection-product--compare")).find(item => item.getAttribute("data-sku") === target_item.getAttribute("data-sku")).querySelector("input").checked = false
    } catch(e) {
        console.error(e)
    }

    handleGAparans(compare_products)
}

function handleRenderCompareList() {
    if(!show_compare) return
    const parent_wrapper = document.querySelector(".compare-wrapper--main");
    const items = parent_wrapper.querySelectorAll(".compare--item")
    const compare_items = Array.from(items).slice(0, items.length - 2);
    compare_items.forEach(item => item.remove())
    compare_products.forEach(item => {
        const htmlString = `<div class="compare--item flex" data-sku="${item.skuId}">
                    <div class="relative compare-img__wrapper">
                        <img src="${item.image}" alt="${item.title}" />
                        <svg class="absolute compare-remove-icon" width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                            <g id="产品集合页-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                <g id="新-产品集合页-4" transform="translate(-1062.000000, -1187.000000)">
                                    <g id="􀅽备份-4" transform="translate(1062.000000, 1187.000000)">
                                        <rect id="矩形" fill="#666666" x="0" y="0" width="16" height="16" rx="8"></rect>
                                        <rect id="矩形" fill="#FFFFFF" x="3" y="7" width="10" height="2" rx="1"></rect>
                                    </g>
                                </g>
                            </g>
                        </svg>
                    </div>
                    <h3 class="text-overflow-3">${item.title}</h3>
        </div>`
        let range = document.createRange();
        let fragment = range.createContextualFragment(htmlString);
        // parent_wrapper.prepend(fragment)

        parent_wrapper.insertBefore(fragment, document.querySelector(".compare--item_add__1"));
    })

    const compare_icons = compare_wrapper.querySelectorAll(".compare-remove-icon");
    compare_icons.forEach(item => {
        item.addEventListener("click", handleRemoveCompareItem)
    })
}

function handleEventCompareHalf() {
    if(!show_compare) return
    const doms = document.querySelectorAll(".compare-wrapper--header-title, .compare--item_add .compare-img__wrapper");
    if(!doms.length) return;
    function handleCompareHalfClick(e) {
        const _t = e.target.closest(".compare-wrapper--header-title")
        if(_t && _t.classList.contains("compare-wrapper--header-title")) {
            compare_wrapper.classList.add("shoudong");
        } else {
            compare_wrapper.classList.remove("shoudong");
        }
        compare_wrapper.classList.toggle("half");
    }
    doms.forEach(item => item.addEventListener("click", handleCompareHalfClick))
}

function handleCompareDom(arr) {
    if(!show_compare) return
    if(!Array.isArray(arr)) return
    const extractValues = (arr, keys) => arr.map(obj => obj[keys]);
    const _variants = extractValues(arr, 'skuId')
    const { add_to_cart_text } = compare_wrapper.dataset
    const popupHtml = `
        <jky-compare 
            class="collection-compare"
            type="3" 
            variantIds="${JSON.stringify(_variants)}"
            newWindow="false"
            addToCartText="${add_to_cart_text}"
        >
            <div class="compare-loading">
                <svg t="1742798686865" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="10744" width="200" height="200"><path d="M512 170.666667C323.477333 170.666667 170.666667 323.477333 170.666667 512s152.810667 341.333333 341.333333 341.333333 341.333333-152.810667 341.333333-341.333333h85.333334c0 235.648-191.018667 426.666667-426.666667 426.666667S85.333333 747.648 85.333333 512 276.352 85.333333 512 85.333333v85.333334z" p-id="10745" fill="#8a8a8a"></path></svg>
            </div>
            <div class="compare-detail">
                <div class="cal_scroll_target selects">
                    <div class="compare-container">
                        <div class="detail-selects"></div>
                    </div>
                </div>
                <div class="compare-container">
                    <div class="detail-main">
                        <div class="detail-products"></div>
                        <div class="detail-diff">
                            <input id="showDiff" class="form-checkbox" type="checkbox" name="showDiff">
                            <label class="form-label checkbox-label" id="checkbox-label" for="showDiff"></label>
                            <span class="info">${show_diff_text}</span>
                        </div>
                        <div class="detail-info"></div>
                    </div>
                </div>
            </div>
        </jky-compare>
    `
    ZModle.updateInstance(popupHtml, {
        id: 'collection-compare-modal',
        class: "collection-compare-modal"
    });
}

function handleCompareStart() {
    if(!show_compare) return
    const start_btns = document.querySelectorAll(".compare-wrapper--sheetButtons .zc_button, .mb__compare_start .zc_button");
    function handleCompareStartClick() {
        if(compare_products.length <= 1) {
            pushErrorMessage(pageInfo.strings.collection.compare_min_limit_tips)
            return
        }

        if(compare_products.length > compare_limit) {
            // pushErrorMessage(`${window.pageInfo?.strings?.collection?.max_limit_local?.replace("<block></block>", compare_limit)}`)
            try {
                pushErrorMessage(`${window.pageInfo?.strings?.collection?.max_limit_local?.replace("<block></block>", compare_limit)}`)
            } catch (error) {
                console.log(error)
            }
            return
        }

        handleCompareDom(compare_products)
    }
    start_btns.forEach(start_btn => start_btn.addEventListener("click", handleCompareStartClick))
    document.querySelector(".compare-wrapper--header h2 span").innerHTML = compare_limit
}

function handleGAparans(products) {
    const limit_num = compare_limit || 3
    if(products.length >= limit_num) {
        document.querySelector(".collection-wrapper").classList.add("max-num")
    } else {
        document.querySelector(".collection-wrapper").classList.remove("max-num")
    }
    const compare_btn_el = document.querySelector(".start_compare")
    if(compare_btn_el) {
        compare_btn_el.setAttribute("data-ga-params-position", products.map(item => item.title).join(','))
    }
}

function handleAddToCompare(event) {
    if(!show_compare) return
    const rect = search_main.getBoundingClientRect();
    if (!search_main.style.getPropertyValue('--pos-x')) {
        search_main.style.setProperty(
        '--pos-x',
        `${Math.floor(rect.x)}px`
        );

        search_main.style.setProperty(
        '--pos-w',
        `${Math.floor(rect.width)}px`
        );
    }

    let dom = event.target
    const pdom = dom.closest('.collection-product--compare');
    if(!pdom) return
    if(!pdom.getAttribute("data-sku")) return

    const result = collection_products.find(item => item.skuId.toString() === pdom.getAttribute("data-sku").toString());
    if(result) {
        if(!dom.checked) {
            compare_products = compare_products.filter(item => item.skuId.toString() !== result.skuId.toString());
            compare_wrapper.querySelector(`.compare--item[data-sku="${result.skuId}"]`) && compare_wrapper.querySelector(`.compare--item[data-sku="${result.skuId}"]`).remove()
            handleUpdataCompareTitle();
            pdom.classList.remove("compare--selected")
        } else {
            pdom.classList.add("compare--selected")
            if(compare_products.length < compare_limit) {
                compare_products = [...compare_products, result]
                handleRenderCompareList()
                compare_wrapper.classList.remove("half");
                handleUpdataCompareTitle();
            } else {
                pdom.querySelector("input").checked = false;
                pdom.classList.remove("compare--selected")
                try {
                    pushErrorMessage(`${window.pageInfo?.strings?.collection?.max_limit_local?.replace("<block></block>", compare_limit)}`)
                } catch (error) {
                    console.log(error)
                }
            }
        }

        if(compare_wrapper && compare_products.length) {
            compare_wrapper.classList.add("open")
            if(!compare_wrapper.classList.contains("shoudong")) {
                compare_wrapper.classList.add("half")
            }
        }

        if(compare_wrapper && !compare_products.length) {
            compare_wrapper.classList.remove("open")
            compare_wrapper.classList.remove("half")
            compare_wrapper.classList.remove("shoudong");
        }
    }


    handleGAparans(compare_products)
}

function handleResize() {
    if(window.innerWidth > 1024) {
        if(!show_compare) return
        const rect = search_main.getBoundingClientRect();
        search_main.style.setProperty(
            '--pos-x',
            `${Math.floor(rect.x)}px`
        );

        search_main.style.setProperty(
            '--pos-w',
            `${Math.floor(rect.width)}px`
        );
    }
}

window.addEventListener('resize', handleResize);
// 产品对比 - end


function handleAddToCart(event) {
    let dom = event.target
    let id = Number(dom.getAttribute("skuid"));
    let quantity = 1
    dom.classList.add("loading");
    if (typeof id !== 'number' || isNaN(id)) {
        throw new TypeError('Theme Cart: Variant ID must be a number');
    }
    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const fetchJSON = (url, config) => {
        return fetch(url, config).then(function(response) {
            if (!response.ok) {
            throw response;
            }
            return response.json();
        });
    }
    const config = fetchConfig('POST');
    config.body = JSON.stringify({
        id: id,
        quantity: quantity
    })


    fetchJSON('/cart/add.js', config).then(response => {
        if(cart && cart.renderContents) {
            cart.renderContents(response);
        } else {
            window.location.href = '/cart'; 
        }
    })
    .catch((e) => {
        throw new TypeError(e);
    })
    .finally(() => {
        setTimeout(() => dom.classList.remove("loading"), 1000)
        if (cart && cart.classList.contains('is-empty')) {
            cart.classList.remove('is-empty');
        }
    })
}

function renderOptions(list, name = '') {
    if(!Array.isArray(list)) return ''
    if(!list.length) return ''
    let res = ''
    list.forEach(option => {
        res += `
        <div 
            item-id="${option.itemId}" 
            selectFlag="${option.selectFlag}" class="trigger-group-option active ${!option.selectFlag ? 'js-disabled' : ''}"
        >
            <div class="zc-checkbox checkbox-label-alignment-start checkbox-label-placement-fixed">
                <label class="checkbox-wrapper">
                    <div class="label-text-wrapper" part="label">
                        <span>${option.itemName}</span>
                    </div>
                    <input 
                        data-ga-event="product_collection4.0_user_clicks" 
                        data-ga-action="change"
                        data-ga-params-module="Filters"
                        data-ga-params-position="${name}"
                        data-ga-params-button_name="${option.itemName}"
                        type="checkbox" data-value="${option.itemId}">
                    <div class="native-wrapper"><svg class="checkbox-icon" viewBox="0 0 24 24"
                            part="container">
                            <path d="M1.73,12.91 8.1,19.28 22.79,4.59" part="mark"></path>
                        </svg></div>
                </label>
            </div>
        </div>
        `
    })
    return res
}

function renderFilterGroups(list) {
    if(!Array.isArray(list)) return ''
    if(!list.length) return ''
    let res = ''
    list.forEach(item => {
        res += `<drop-down class="filters-group-dropdown_main" doc="false">
                <div trigger>
                    <div class="trigger-group-summery">
                        <span>${item.itemName}</span>
                        <span class="trigger-group--icon"></span>
                    </div>
                </div>

                <div trigger-content class="drop-down--detail">
                    <div class="trigger--detail">
                        ${item.childrenList.length ? renderOptions(item.childrenList, item.itemName) : ''}
                    </div>
                </div>
            </drop-down>`
    })
    return res
}

function setOptionStatus(list) {
    list.forEach(item => {
        if(Array.isArray(item.childrenList)) {
            item.childrenList.forEach(option => {
                const target = document.querySelector(`[item-id='${option.itemId}']`)
                if(!target) return
                if(!option.selectFlag) {
                    target.classList.add('js-disabled')
                } else {
                    target.classList.remove('js-disabled')
                }
            })
        }
    })
}

function renderProductList(list, next = false, count = 0) {
    if(!Array.isArray(list)) return ''
    if(!count) {
        product_grid.innerHTML = ''
        fk_no_data.classList.add("active")
        return ''
    } else {
        fk_no_data.classList.remove("active")
    }
    if(!list.length) return;
    const open_new = document.querySelector(".collection-wrapper").getAttribute("data-open") === "true"
    const add_cart_solid = document.querySelector(".collection-wrapper").getAttribute("data-add_cart_solid") === "true"
    const shop_solid = document.querySelector(".collection-wrapper").getAttribute("data-shop_solid") === "true"
    const free_tax = document.querySelector(".collection-wrapper").getAttribute("data-freetax")
    // 是否开启了 自动折扣价
    const open_auto_discount_price = document.querySelector(".collection-wrapper").getAttribute("data-open-auto-discount-price") === "true"
    // 折扣角标
    const data_discount_tag_display_style = document.querySelector(".collection-wrapper").getAttribute("data-discount-tag-display-style")
    const discount_amount_display_style = document.querySelector(".collection-wrapper").getAttribute("data-discount-amount-display-style")
    const discount_percent_display_style = document.querySelector(".collection-wrapper").getAttribute("data-discount-percent-display-style")
    let res = ''
    list.forEach(item => {
        const current_price = Math.min(item.autoDiscountPrice || 0, item.shopifyFrontprice || 0)
        const origin_price = Math.max(item.autoDiscountPrice || 0, item.shopifyFrontprice || 0, item.shopifyFrontOriginalPrice || 0)
        let money_format = window?.pageInfo?.currency?.money_format?.replace('{{amount}}', '{{amount_no_decimals}}')
        money_format = money_format?.replace('{{amount_with_comma_separator}}', '{{amount_no_decimals_with_comma_separator}}')
        const discount_amount = formatMoney(Math.floor(item.autoDiscountAmount / 100) * 100, money_format)
        res += `
        <div class="collection-product-item" goods-id="${item.goodsId}" data-sku="${item.skuId}">
                ${item.productTagImage ? '<img class='+'p_tag'+' src='+item.productTagImage+' alt />' : ''}
                ${item.promotion
                  ? '<span class='+'p_promotion_tag'+'>'+item.promotion+'</span>'
                  : open_auto_discount_price 
                    ? data_discount_tag_display_style === 'amount'
                        ? item.autoDiscountAmount > 0 ? `<span class="p_promotion_tag">${discount_amount_display_style.replace('()', discount_amount)}</span>` : ''
                        : item.autoDiscountPercentage > 0 ? `<span class="p_promotion_tag">${discount_percent_display_style.replace('()', item.autoDiscountPercentage)}</span>` : ''
                    : ''
                }
                <div class="collection-product-card">
                    <a 
                        data-ga-event="product_collection4.0_user_clicks" 
                        data-ga-action="click"
                        data-ga-params-module="Product"
                        data-ga-params-link="${item.goodsUrl}"
                        data-ga-params-position="${item.title}"
                        data-ga-params-button_name="${item.saleFlag ? pageInfo.strings.collection.addToCart : pageInfo.strings.collection.soldOut}"
                    ${open_new ? 'target="_blank"' : ''} style="position: absolute;width:100%;height: 100%;top: 0;left:0;" href="${item.goodsUrl}"></a>
                    <a 
                        ${open_new ? 'target="_blank"' : ''} 
                        href="${item.goodsUrl}"
                        data-ga-event="product_collection4.0_user_clicks" 
                        data-ga-action="click"
                        data-ga-params-module="Product"
                        data-ga-params-link="${item.goodsUrl}"
                        data-ga-params-position="${item.title}"
                        data-ga-params-button_name="${item.saleFlag ? pageInfo.strings.collection.addToCart : pageInfo.strings.collection.soldOut}"
                    ><img class="p__img" src="${item.image}" alt="${item.title}"></a>
                    <div class="p__content">
                        <div class="p__info">
                            <a 
                                data-ga-event="product_collection4.0_user_clicks" 
                                data-ga-action="click"
                                data-ga-params-module="Product"
                                data-ga-params-link="${item.goodsUrl}"
                                data-ga-params-position="${item.title}"
                                data-ga-params-button_name="${item.saleFlag ? pageInfo.strings.collection.addToCart : pageInfo.strings.collection.soldOut}"
                                ${open_new ? 'target="_blank"' : ''} href="${item.goodsUrl}" class="p__title text-overflow-2"><h2>${item.title}</h2></a>
                            <div class="p__des text-overflow-2">${item.productFeaturesInfoList ? item.productFeaturesInfoList.join('<br>') : ''}</div>
                        </div>

                        <div class="p__content--bottom">
                            <div class="p__price" ${free_tax ? `style="gap:5px"`: ''}>
                                ${
                                    open_auto_discount_price && item.autoDiscountPrice > 0
                                        ? `<span class="price">${formatMoney(current_price, pageInfo.currency.money_format)}</span>`
                                        : `<span class="price">${formatMoney(item.shopifyFrontprice, pageInfo.currency.money_format)}</span>`
                                }
                                ${free_tax ? `<span class="origin-price" style="color:#fd5000;text-decoration:none">${free_tax}</span>` : ''}
                                ${
                                    open_auto_discount_price && item.autoDiscountPrice > 0
                                        ? `<span class="origin-price">${
                                            origin_price > current_price
                                                ? formatMoney(origin_price, pageInfo.currency.money_format)
                                                : ''
                                            }</span>`
                                        : `<span class="origin-price">${item.shopifyFrontOriginalPrice ? formatMoney(item.shopifyFrontOriginalPrice, pageInfo.currency.money_format) : ''}</span>`
                                }
                            </div>

                            ${pageInfo.strings.collection.addToCart ?
                            `<div 
                                skuid="${item.skuId}" 
                                class="relative p__add_to_cart zc_button ${item.saleFlag ? '' : 'disabled'} ${add_cart_solid ? 'index-button btn-solid' : ''}"
                                data-ga-event="product_collection4.0_user_clicks" 
                                data-ga-action="click"
                                data-ga-params-module="Product"
                                data-ga-params-position="${item.title}"
                                data-ga-params-button_name="${item.saleFlag ? pageInfo.strings.collection.addToCart : pageInfo.strings.collection.soldOut}"
                            >
                            <div class="loading__spinner loading__spinner__dark">
                                <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                                    <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                                </svg>
                            </div>
                             ${item.saleFlag ? pageInfo.strings.collection.addToCart : pageInfo.strings.collection.soldOut}
                                        </div>`
                                        : ''}
                             
                            ${pageInfo.strings.collection.shopNow ?
                                `<a href="${item.goodsUrl}" ${open_new ? 'target="_blank"' : ''}
                                    class="shop-now ${shop_solid ? 'index-button btn-solid' : ''}"
                                >
                                    <span> ${pageInfo.strings.collection.shopNow}</span>
                                </a>`
                            : ''}

                        </div>
                    </div>
                </div>

                <div class="collection-product--compare ${show_compare ? '' : 'display-none'}" goods-id="${item.goodsId}" data-sku="${item.skuId}">
                    <div class="zc-checkbox checkbox-label-alignment-start checkbox-label-placement-fixed" style="--border-color-checked: #000;--checkbox-background-checked: #000;">
                        <label class="checkbox-wrapper">
                            <div class="label-text-wrapper" part="label">
                                <span>${pageInfo.strings.collection.compare_button_text}</span>
                            </div>
                            <input type="checkbox">
                            <div class="native-wrapper"><svg class="checkbox-icon" viewBox="0 0 24 24" part="container">
                                    <path d="M1.73,12.91 8.1,19.28 22.79,4.59" part="mark"></path>
                                </svg></div>
                        </label>
                    </div>
                </div>
            </div>
        `
    })
    
    if(next) {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = res;
        const fragment = document.createDocumentFragment();
        while (tempDiv.firstChild) {
            fragment.appendChild(tempDiv.firstChild);
        }
        
        if(window.innerWidth >= 1024) {
            product_grid.innerHTML = ''
            product_grid.appendChild(fragment);
        } else {
            product_grid.appendChild(fragment);
        }
    } else {
        product_grid.innerHTML = res
    }

    show_compare && setTimeout(() => {
        document.querySelectorAll(".collection-product--compare input").forEach(item => {
            item.removeEventListener("click", handleAddToCompare)
            item.addEventListener("click", handleAddToCompare);
        })
    }, 100)
}

function handleCollectionCount(count = 0) {
    const _dom = document.querySelector(".collection--heading-count")
    if(!_dom) return
    _dom.textContent = _dom.textContent.replace("$count", count)
    _dom.classList.add("is-active");
}

function fetchList(init = false, params = {}, next = false) {
    if(loading_next) return
    if(next) { loading_next = true; }
    !next && search_main.classList.remove("loaded")

    document.querySelectorAll(".filters-group-container drop-down .trigger-group-option .zc-checkbox").forEach(i => i.classList.add("checkbox-disabled"))
    document.querySelector(".filters-toolbar-dropdown_main").classList.add("js-disabled")
    const scrollTop = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
    !init && !next && window.scrollTo({
        top: document.querySelector(".collection-wrapper").getBoundingClientRect().y + scrollTop - document.querySelector("header").getBoundingClientRect().bottom,
        behavior: 'smooth'
    });
    
    const config = fetchConfig("POST")
    config.body = JSON.stringify({
        "shopifyShopId": pageInfo.shopId,
        "categoryName": document.querySelector(".collection-wrapper").getAttribute("data-handle"), 
        "limit": window.innerWidth >= 1024 ? 9 : 6,
        ...params
    })
    fetch(`${pageInfo.api}/osconsumerapi/v1/category/product`, config)
    .then((response) => response.json())
    .then((res) => {
        setTimeout(() => {
            document.querySelectorAll(".filters-group-container drop-down .trigger-group-option .zc-checkbox").forEach(i => i.classList.remove("checkbox-disabled"))
        }, 0);
            const _products = res?.data?.productRespPage?.data || []
            collection_products = collection_products.concat(_products)
            loading_next = false
            if(mql.matches) {
                document.querySelector(".mb-view-filters--btn block").innerHTML = res?.data?.productRespPage?.count
            }
            if(init) {
                filters_main.classList.add("loaded")
                const _inner = renderFilterGroups(res?.data?.cusCategoryItemResps || [])
                filters_groups.innerHTML = _inner
                document.querySelectorAll(".filters-group-container drop-down .trigger-group-option").forEach(item => {
                    item.querySelector("input").addEventListener("change", function(e) {
                        if(e?.target?.checked) {
                            renderSelectedFilter(item.getAttribute("item-id"))
                        } else {
                            handleDeleteFilter(item.getAttribute("item-id"))
                        }

                        __page_index = 1
                        updatePaginationNum(1)
                        updateBtnStatus()
                        FormatSearchParams()

                        try {
                            document.querySelector(".sheetButtons--clear")?.click()
                        } catch (error) {
                            console.warn("sheetButtons--clear click error")
                        }
                    })
                })

                handleGaEvents(filters_groups)

                // 接口需要新加字段-数量总和
                handleCollectionCount(res?.data?.productRespPage?.allCount)

                // 初始化已选择搜索条件
                params.itemIdList && params.itemIdList && Array.isArray(params.itemIdList) && params.itemIdList.forEach(id => renderSelectedFilter(id))

                updatePaginationNum(1)
            } else {
                setOptionStatus(res?.data?.cusCategoryItemResps || [])
            }
            renderProductList(res?.data?.productRespPage?.data || [], next, res?.data?.productRespPage?.count || 0)
            handleGaEvents(document.querySelector(".result-product-grid"))

            try {
                setTimeout(() => {
                    resault_amount && (resault_amount.innerHTML = res?.data?.productRespPage?.count || 0)
                }, 20);
                handleMobilePaginationStatus(res?.data?.productRespPage?.count || 0)
            } catch (error) {
                console.log(error)
            }

            document.querySelectorAll(".p__add_to_cart").forEach(item => {
                item.removeEventListener("click", handleAddToCart)
                item.addEventListener("click", handleAddToCart);
            })

            // 分页-初始化分页总数
            __page_count = Math.ceil(res?.data?.productRespPage?.count / 9) || 1
            updatePaginationCount(__page_count)

            search_main.classList.add("loaded")
            document.querySelector(".filters-toolbar-dropdown_main").classList.remove("js-disabled")
            init && initFiltersStatus(params)
    })
}

function updateQuery(params = {}) {
    if(!params.itemIdList) return
    if(!Array.isArray(params.itemIdList)) return ''
    const sort = document.querySelector(".filters-toolbar-dropdown_main")
    let res = ''
    if(params.itemIdList.length) {
      res = window.innerWidth >= 1024 ? `?itemIds=${params.itemIdList.join('+')}&sort_by=${params.sortBy}&page=${__page_index}` : `?itemIds=${params.itemIdList.join('+')}&sort_by=${params.sortBy}`
    } else {
      res = window.innerWidth >= 1024 ? `?sort_by=${params.sortBy}&page=${__page_index}` : `?sort_by=${params.sortBy}`
    }
    window.history.replaceState({}, '', `${location.pathname}${res}`);
}

function initFiltersStatus(params = {}) {
    if(params.itemIdList) {
        if(Array.isArray(params.itemIdList)) {
            console.log("initFiltersStatus", params)
            params.itemIdList.forEach(item => {
                const target = document.querySelector(`.filters-group-container [item-id='${item}']`)

                if(!target) return
                target.classList.add('active')
                target.querySelector("input").checked = true
            })
        }
    }

    const sort_target = document.querySelector(`[data-value='${params.sortBy}']`)
    if(sort_target) {
        document.querySelectorAll(".filters-toolbar-dropdown_main .trigger--detail-item").forEach((option) => option.classList.remove("active"))
        sort_target.classList.add("active")
        document.querySelector(".trigger--summery span.text-overflow-1").innerHTML = sort_target.innerHTML
    }
}

function initQuery() {
    let url = window.location.href;
    let queryString = url.split('?')[1];
    let queryParams = {};
    if (queryString) {
        let pairs = queryString.split('&');
        for (let i = 0; i < pairs.length; i++) {
            let pair = pairs[i].split('=');
            let key = decodeURIComponent(pair[0]);
            let value = decodeURIComponent(pair[1]);
            queryParams[key] = value;
        }
    }

    __page_index = Number(queryParams.page) || 1
    __page_index !== 1 && setTimeout(() => {
        updatePaginationNum(__page_index)
    }, 1000);
    const _params = {
        itemIdList: queryParams.itemIds !== "undefined" ? (queryParams.itemIds?.split("+") || []) : [],
        sortBy: queryParams.sort_by
    }
    window.innerWidth >= 1024 && (_params.page = queryParams.page || 1)
    fetchList(true, {..._params}, false)

    if(show_compare) {
        handleEventCompareClear()
        handleEventCompareHalf()
        const compare_icons = compare_wrapper.querySelectorAll(".compare-remove-icon");
        compare_icons.forEach(item => {
            item.addEventListener("click", handleRemoveCompareItem)
        })
        handleCompareStart()
    }

    fk_no_data.querySelector(".zc_button").addEventListener("click", clearAllFilters)
}
initQuery()

function FormatSearchParams(next = false) {
    const sort = document.querySelector(".filters-toolbar-dropdown_main")
    let res = []
    document.querySelectorAll(".filters-group-container drop-down").forEach(dropDown => {
        dropDown.querySelectorAll(".trigger-group-option input").forEach(input_checkbox => {
            input_checkbox.checked && res.push(input_checkbox.getAttribute("data-value"))
        })
    })
    const _params = {itemIdList: res, sortBy: sort?.querySelector(".trigger--detail-item.active")?.getAttribute("data-value"), page: __page_index}

    updateQuery(_params)

    !next && fetchList(false, {itemIdList: res, sortBy: sort?.querySelector(".trigger--detail-item.active")?.getAttribute("data-value"), page: __page_index})
    return _params;
}


/* 更新已选搜索条件 */
function renderSelectedFilter(ids) {
    if(!ids) return;
    const _target = selectedFilters.querySelector(`.selected-filters-item[item-id="${ids}"]`);
    if(_target) return;
    
    const text = document.querySelector(`.trigger--detail [item-id='${ids}'] .label-text-wrapper span`)?.textContent || ''
    const html = `<div item-id="${ids}" class="selected-filters-item">
        <span class="text-overflow-1">${text}</span>
        <svg 
            class="selected-filters-close" xmlns="http://www.w3.org/2000/svg" fill="#666666" viewBox="0 0 24 24" stroke-width="1.5" stroke="#666666" aria-hidden="true" width="16" height="16">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
    </div>`
    let range = document.createRange();
    let fragment = range.createContextualFragment(html);
    fragment.querySelector(".selected-filters-close").addEventListener("click", () => {
        const _input = document.querySelector(`.trigger--detail [item-id='${ids}'] input`)
        if(_input) {
            _input.checked = false
            const event = new Event('change', {
                bubbles: true,
                cancelable: true
            });
            _input.dispatchEvent(event);
        }
    })
    selectedFilters.insertBefore(fragment, selectedFilters.querySelector(".selected-filters-clear"));
    selectedFilters.classList.remove("hide")
}

function handleDeleteFilter(ids) {
    if(!ids) return
    const target = selectedFilters.querySelector(`.selected-filters-item[item-id="${ids}"]`);
    target && target.remove()
    if(!selectedFilters.querySelectorAll(".selected-filters-item")?.length) {
        selectedFilters.classList.add("hide")
    }
}


selectedFilters.querySelector(".selected-filters-clear") && selectedFilters.querySelector(".selected-filters-clear").addEventListener("click", () => {
    selectedFilters.querySelectorAll(".selected-filters-item").forEach(item => {
        item.remove()
        selectedFilters.classList.add("hide")
    })
    clearAllFilters()
})
/* 更新已选搜索条件 */



/* 分页控制 - start */
function updatePaginationNum(num = 1) { // 更新分页-当前页数
    const _dom = document.querySelector(".collection-pagination__count")
    if(!_dom || !_dom.querySelector(".collection-pagination__current")) return
    _dom.querySelector(".collection-pagination__current").textContent = num || 1
}
function updatePaginationCount(num = 0) { // 更新分页-总页数(初始化)
    const _dom = document.querySelector(".collection-pagination__count")
    if(!_dom || !_dom.querySelector(".collection-pagination__total_count")) return
    if(num === 0) {
        document.querySelector(".collection-pagination-wrapper").classList.add("hide")
    } else {
        document.querySelector(".collection-pagination-wrapper").classList.remove("hide")
    }
    _dom.querySelector(".collection-pagination__total_count").textContent = num || 1
    
    setTimeout(() => { updateBtnStatus() }, 2000);
}
function updateBtnStatus() { // 更新分页按钮状态
    const wrapper = document.querySelector(".collection-pagination-wrapper")
    if(!wrapper) return
    const next = wrapper.querySelector(".collection-pagination__next")
    const prev = wrapper.querySelector(".collection-pagination__prev")

    try {
        if(__page_index == 1) {
            prev.classList.add("is-disabled")
        } else {
            prev.classList.remove("is-disabled")
        }

        if(__page_index == __page_count) {
            next.classList.add("is-disabled")
        } else {
            next.classList.remove("is-disabled")
        }
    } catch (error) {
        console.warn("updateBtnStatus error", error)
    }
}
function LoadNext() {
    if(loading_next) return
    __page_index = __page_index + 1
    const params = FormatSearchParams(true)
    fetchList(false, params, true)
}

function handleMobilePaginationStatus(count = 0) {
    if(window.innerWidth < 1024) {
        if(count<= 6) {
            next_mb && next_mb.classList.add("hide")
        } else {
            next_mb && next_mb.classList.remove("hide")
        }
    }
}

prev_page.addEventListener("click", () => {
    if(__page_index > 1) {
        __page_index = __page_index - 1
        updatePaginationNum(__page_index)
        next_page.classList.remove("is-disabled")

        __page_index == 1 && prev_page.classList.add("is-disabled")
        FormatSearchParams();
    } else {
        prev_page.classList.add("is-disabled")
    }
})

next_page.addEventListener("click", () => {
    if(__page_index < __page_count) {
        __page_index = __page_index + 1
        updatePaginationNum(__page_index)
        prev_page.classList.remove("is-disabled")

        __page_index == __page_count && next_page.classList.add("is-disabled")
        FormatSearchParams();
    } else {
        next_page.classList.add("is-disabled")
    }
})

window.innerWidth < 1024 && next_mb.addEventListener("click", () => {LoadNext()})
/* 分页控制 - end */




function clearAllFilters() {
    document.querySelectorAll(".filters-group-container drop-down").forEach(dropDown => {
        dropDown.querySelectorAll(".trigger-group-option input").forEach(input_checkbox => {
            if(input_checkbox.checked) {
                input_checkbox.checked = false
            }
        })
    })

    const params = FormatSearchParams(false)
    fetchList(false, params, false)
    fk_no_data.classList.remove("active")
}

document.querySelectorAll(".filters-toolbar-dropdown_main .trigger--detail-item").forEach(item => {
    item.addEventListener("click", function() {
        __page_index = 1
        updatePaginationNum(1)
        updateBtnStatus()

        document.querySelectorAll(".filters-toolbar-dropdown_main .trigger--detail-item").forEach(_i => _i.classList.remove("active"))
        this.classList.add("active")
        document.querySelector(".filters-toolbar-dropdown_main .trigger--summery span.text-overflow-1").innerText = this.innerText
        document.querySelector(".filters-toolbar-dropdown_main")?.close()
        FormatSearchParams()

        try {
            document.querySelector(".sheetButtons--clear")?.click()
        } catch (error) {
            console.warn("sheetButtons--clear click error")
        }
    })
})

if(mql.matches) {
    document.querySelector(".filters-trigger").addEventListener("click", () => {
        document.querySelector("body").style.setProperty(
        '--header-bottom-position',
        `${Math.floor(document.querySelector("header").getBoundingClientRect().bottom)}px`
        );
        document.querySelector(".filters-container").classList.add("open")
        document.querySelector(".filters--overlay").classList.add("active")
        document.querySelector("body").classList.add("overflow-hidden")
    })

    document.querySelector(".filters--btn-close").addEventListener("click", () => {
        document.querySelector(".filters-container").classList.remove("open")
        document.querySelector(".filters--overlay").classList.remove("active")
        document.querySelector("body").classList.remove("overflow-hidden")
    })

    document.querySelector(".filters--overlay").addEventListener("click", () => {
        document.querySelector(".filters-container").classList.remove("open")
        document.querySelector(".filters--overlay").classList.remove("active")
        document.querySelector("body").classList.remove("overflow-hidden")
    })
    document.querySelector(".mb-view-filters--btn").addEventListener("click", () => {
        document.querySelector(".filters-container").classList.remove("open")
        document.querySelector(".filters--overlay").classList.remove("active")
        document.querySelector("body").classList.remove("overflow-hidden")
    })
}

class DropDown extends HTMLElement {
    constructor() {
        super();
        this.trigger = this.querySelector("[trigger]")
        this.content = this.querySelector("[trigger-content]")
        this.unDocClickAble = this.getAttribute("doc") === "false"
        if(this.trigger && this.content) {
            this.initClickTrigger()
            !this.unDocClickAble && document.addEventListener("click", this.docClick.bind(this))
        }
    }

    disconnectedCallback() {
        this.trigger.removeEventListener("click", this.handleClick.bind(this))
        !this.unDocClickAble && document.removeEventListener("click", this.docClick.bind(this))
    }

    handleClick(e) {
        e.preventDefault()
        this.hasAttribute("open") ? this.close() : this.open()
    }

    initClickTrigger() {
        this.trigger.addEventListener("click", this.handleClick.bind(this))
    }


    docClick(e) {
        if (this.contains(e.target)) return;
        this.close()
    }

    open() {
        if(this.classList.contains("closing")) return
        this.classList.add("opending")
        this.setAttribute("open", !0)
        this.setAttribute("aria-expanded", !0)
        this.content.style.display = "block"
        const height = this.content.scrollHeight;
        this.content.style.maxHeight = height + 'px';
        setTimeout(() => {
            this.classList.remove("opending")
        }, 300);
    }
  
    close() {
        if(this.classList.contains("opending")) return
        this.classList.add("closing")
        this.removeAttribute("open")
        this.setAttribute("aria-expanded", !1)
        this.content.style.maxHeight = '0';
        setTimeout(() => {
            this.content.style.display = 'none';
            this.classList.remove("closing")
        }, 300);
    }
}
customElements.define("drop-down", DropDown);

})